export default __webpack_public_path__ + "static/joko-app-screenshot-home-1-fr@2x-52f6cdb2828d483e4dab73c8e1791c89.webp";